function prepareInstitutionData(institutions) {
  if (!institutions || institutions.length < 1 || Object.keys(institutions).length === 0) {
    return [];
  }

  const orderedInstitutions = institutions.sort(function (a, b) {
    return a.dollars > b.dollars ? -1 : 1;
  });

  const numberFormatter = new Intl.NumberFormat('en-US', {
    'maximumFractionDigits': 0
  });

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    'style': 'currency',
    'currency': 'USD',
    'minimumFractionDigits': 0,
    'maximumFractionDigits': 0
  });

  const fractionalCurrencyFormatter = new Intl.NumberFormat('en-US', {
    'style': 'currency',
    'currency': 'USD',
    'minimumFractionDigits': 0,
    'maximumFractionDigits': 1
  });

  const preparedInstitutions = orderedInstitutions.map(institution => {
    // Round jobs to a whole number.
    institution.jobs = Math.round(institution.jobs);

    return institution;
  }).filter(institution => {
    // Do not display institution without any Jobs.
    if (!institution.jobs) {
      return false;
    }

    return true;
  }).map(institution => {
    // Format Output of Jobs and Dollars.
    institution.jobs = numberFormatter.format(institution.jobs);

    // Use Billions if > 1000000000.
    if (institution.dollars > 1000000000) {
      // Round dollars to the nearest 10th millions.
      institution.dollars = Math.round(institution.dollars / 100000000) / 10;
      institution.dollars = fractionalCurrencyFormatter.format(institution.dollars) + ' billion';
    }
    // Use Millions if > 1000000.
    else if (institution.dollars > 1000000) {
      // Round dollars to the nearest 10th millions.
      institution.dollars = Math.round(institution.dollars / 100000) / 10;
      institution.dollars = fractionalCurrencyFormatter.format(institution.dollars) + ' million';
    }
    else {
      // Round dollars to the nearest 10th.
      institution.dollars = Math.round(institution.dollars * 10) / 10;
      institution.dollars = currencyFormatter.format(institution.dollars);
    }

    return institution;
  });

  return preparedInstitutions;
}

function prepareStateData(items) {
  if (!items || Object.keys(items).length === 0) {
    return [];
  }

  const numberFormatter = new Intl.NumberFormat('en-US', {
    'maximumFractionDigits': 0
  });

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    'style': 'currency',
    'currency': 'USD',
    'minimumFractionDigits': 0,
    'maximumFractionDigits': 0
  });

  const fractionalCurrencyFormatter = new Intl.NumberFormat('en-US', {
    'style': 'currency',
    'currency': 'USD',
    'minimumFractionDigits': 0,
    'maximumFractionDigits': 1
  });

  const preparedItems = items.map(item => {
    item.jobs = numberFormatter.format(item.jobs);
    item.students = numberFormatter.format(item.students);

    // Use Billions if > 1000000000.
    if (item.dollars > 1000000000) {
      // Round dollars to the nearest 10th millions.
      item.dollars = Math.round(item.dollars / 100000000) / 10;
      item.dollars = fractionalCurrencyFormatter.format(item.dollars) + ' billion';
    }
    // Use Millions if > 1000000.
    else if (item.dollars > 1000000) {
      // Round dollars to the nearest 10th millions.
      item.dollars = Math.round(item.dollars / 100000) / 10;
      item.dollars = fractionalCurrencyFormatter.format(item.dollars) + ' million';
    }
    else {
      // Round dollars to the nearest 10th.
      item.dollars = Math.round(item.dollars * 10) / 10;
      item.dollars = currencyFormatter.format(item.dollars);
    }

    return item;
  });

  return preparedItems;
}

function isSingleDistrictState(state) {
  const statesWithOneDistrict = [
    'AK',
    'DC',
    'DE',
    'ND',
    'SD',
    'VT',
    'WY',
  ];

  return statesWithOneDistrict.includes(state)
}



/**
 * Gets whether or not this is embargo data.
 */
function isEmbargoPath() {
  if (!drupalSettings) {
    // Drupal Settings not loaded yet.
    // Defaulting to FALSE.
    return false;
  }

  return drupalSettings.isev_embargo;
}

export { prepareInstitutionData, prepareStateData, isSingleDistrictState, isEmbargoPath }
